/**
 * Development / non-prod builds: dev API host (see proxy.conf.json for local /api routing).
 */
export const environment = {
  production: false,
  /** Empty string = same origin as the Angular dev server; proxy forwards /api to AIO. */
  apiBaseUrl: 'https://aiodevbackend01-gpaacvfhg4fvbsas.eastus2-01.azurewebsites.net',
  loginUrl: '/api/auth/shard/login',
  logoutUrl: '/api/auth/shard/logout',
  mfaVerifyUrl: '/api/auth/shard/login-mfa-verify',
  mfaResendUrl: '/api/auth/shard/login-mfa-resend',
};
